import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _defineProperty from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import _regeneratorRuntime from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.keys.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';;
import { range, union, map, find } from 'lodash';
import CitySelect from "./CitySelect";
import TypologyCategory from 'src/store/models/TypologyCategory';
import { Money } from 'v-money';
// import StateSelect from './StateSelect'
var DEFAULT_FILTERS = {
  type: null,
  contract: 'sale',
  from_price: 0,
  to_price: 0,
  from_area: 0,
  to_area: 0,
  typology_category_ids: [],
  bathrooms: null,
  rooms: null,
  delivery: null // ,
  // company_id: null,
  // city_ids: []
};

export default {
  props: {
    filters: {
      type: Object,
      default: function _default() {
        return _objectSpread(_objectSpread({}, DEFAULT_FILTERS), {}, {
          company_id: null,
          city_ids: []
        });
      }
    },
    showFilters: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    dialog: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    noToolbar: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    cities: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    filtersCount: {
      type: Number,
      default: 0
    }
  },
  components: {
    QOptionGroup: QOptionGroup,
    CitySelect: CitySelect,
    Money: Money
  },
  data: function data() {
    return {
      deliveryOptions: [{
        label: this.$t('Nessuna limitazione'),
        value: null,
        color: 'brand'
      }, {
        label: this.$t('Pronta consegna'),
        value: 'delivered',
        color: 'brand'
      }, {
        label: this.$t('Pronta consegna o a 6 mesi'),
        value: 'six_months_delivery',
        color: 'brand'
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' €',
        precision: 0,
        masked: false
      }
    };
  },
  watch: {
    filters: function filters(val) {
      if (this.noToolbar) {
        this.$emit('update:filters', this.filters);
        this.$emit('filtersUpdated');
      }
    },
    stringFilter: function stringFilter() {
      this.$emit('update:filtersCount', this.stringFilter ? this.stringFilter.split(',').length : 0);
    }
  },
  computed: {
    allTypologies: function allTypologies() {
      return this.filters.typology_category_ids.length === 0;
    },
    stringFilter: function stringFilter() {
      var _this = this;
      var string = '';
      switch (this.filters.type) {
        case 'residential':
          string += this.$t('Residenziale') + ', ';
          break;
        case 'commercial':
          string += this.$t('Commerciale') + ', ';
          break;
        case 'terrain':
          string += this.$t('Terreno') + ', ';
          break;
      }
      switch (this.filters.contract) {
        case 'sale':
          string += this.$t('In vendita') + ', ';
          break;
        case 'rent':
          string += this.$t('In affitto') + ', ';
          break;
      }

      // Typologies
      if (this.filters.typology_category_ids.length > 0) {
        this.filters.typology_category_ids.forEach(function (typologyCategoryId) {
          var typologyCategory = find(_this.typologyCategories, {
            id: typologyCategoryId
          });
          if (typologyCategory) {
            string += "".concat(typologyCategory.name, ", ");
          }
        });
      }
      if (this.filters.from_price) {
        string += "".concat(this.$t('da'), " ").concat(this.filters.from_price.getFormattedCurrency(), ", ");
      }
      if (this.filters.to_price) {
        string += "".concat(this.$t('fino a'), " ").concat(this.filters.to_price.getFormattedCurrency(), ", ");
      }
      if (this.filters.from_area) {
        string += "".concat(this.$t('da'), " ").concat(this.filters.from_area, " mq, ");
      }
      if (this.filters.to_area) {
        string += "".concat(this.$t('fino a'), " ").concat(this.filters.to_area, " mq, ");
      }
      if (this.filters.bathrooms) {
        string += "".concat(this.filters.bathrooms, " ").concat(this.$t('bagni'), ", ");
      }
      if (this.filters.rooms) {
        string += "".concat(this.filters.rooms, " ").concat(this.$t('camere'), ", ");
      }
      switch (this.filters.delivery) {
        case 'delivered':
          string += this.$t('Pronta consegna') + ', ';
          break;
        case 'six_months_delivery':
          string += this.$t('Pronta consegna o a 6 mesi') + ', ';
          break;
      }
      string = string.replace(/,\s*$/, '');
      // If the string is empty, return the default string
      if (string === '') {
        string = this.$t('Nessun filtro');
      }
      return string;
    },
    minPriceOptions: function minPriceOptions() {
      return map(union(range(20000, 100000, 10000), range(100000, 500000, 20000), range(500000, 1000000, 50000), range(1000000, 3000000, 200000), range(3000000, 5500000, 500000)), function (price) {
        return {
          label: price.toLocaleString('it-IT') + ' €',
          value: price
        };
      });
    },
    maxPriceOptions: function maxPriceOptions() {
      return map(union(range(20000, 100000, 10000), range(100000, 500000, 20000), range(500000, 1000000, 50000), range(1000000, 3000000, 200000), range(3000000, 5500000, 500000)), function (price) {
        return {
          label: price.toLocaleString('it-IT') + ' €',
          value: price
        };
      });
    },
    minRentOptions: function minRentOptions() {
      return map(union(range(300, 1000, 100), range(1000, 2000, 200), range(2000, 4500, 500)), function (price) {
        return {
          label: price.toLocaleString('it-IT') + ' €',
          value: price
        };
      });
    },
    maxRentOptions: function maxRentOptions() {
      return map(union(range(300, 1000, 100), range(1000, 2000, 200), range(2000, 4500, 500)), function (price) {
        return {
          label: price.toLocaleString('it-IT') + ' €',
          value: price
        };
      });
    },
    minAreaOptions: function minAreaOptions() {
      return map(union(range(25, 200, 5), range(200, 1001, 10)), function (area) {
        return {
          label: area + ' mq',
          value: area
        };
      });
    },
    maxAreaOptions: function maxAreaOptions() {
      var options = union(range(25, 200, 5), range(200, 1001, 10));
      options.push('1000+');
      return map(options, function (area) {
        return {
          label: area + ' mq',
          value: area
        };
      });
    },
    typologyCategories: function typologyCategories() {
      return TypologyCategory.query().orderBy('order_number').get();
    },
    commercialCategories: function commercialCategories() {
      return TypologyCategory.query().orderBy('order_number').where('commercial', true).get();
    },
    residentialCategories: function residentialCategories() {
      return TypologyCategory.query().orderBy('order_number').where('residential', true).get();
    }
  },
  methods: {
    toggleTypologies: function toggleTypologies() {
      if (this.filters.typology_category_ids.length) {
        this.filters.typology_category_ids = [];
      }
    },
    toggleCategoryId: function toggleCategoryId(categoryId) {
      var index = this.filters.typology_category_ids.indexOf(categoryId);
      if (index !== -1) {
        this.filters.typology_category_ids.splice(index, 1);
      } else {
        this.filters.typology_category_ids.push(categoryId);
      }
    },
    updateFilters: function updateFilters() {
      this.$emit('update:filters', this.filters);
      this.$emit('filtersUpdated');
      this.$emit('update:showFilters', false);
    },
    resetFilters: function resetFilters() {
      var _this2 = this;
      Object.keys(DEFAULT_FILTERS).forEach(function (key) {
        _this2.filters[key] = DEFAULT_FILTERS[key];
      });
      this.$emit('update:filters', this.filters);
      this.$emit('filtersUpdated');
      this.$emit('update:showFilters', false);
    }
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return TypologyCategory.api().get('/api/typology-categories');
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};